export interface Page<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
}

export const PAGE_SIZE = 50;

/** Shared options for offset-paged `{items,total,limit,offset}` lists with useInfiniteQuery. */
export const offsetPaging = {
  initialPageParam: 0,
  getNextPageParam: (last: Page<unknown>): number | undefined => {
    const next = last.offset + last.items.length;
    return next < last.total ? next : undefined;
  },
} as const;

export const flattenPages = <T>(pages: readonly Page<T>[] | undefined): T[] =>
  pages ? pages.flatMap((p) => p.items) : [];
